import script from "./role-list.vue?vue&type=script&setup=true&lang=js"
export * from "./role-list.vue?vue&type=script&setup=true&lang=js"

import "./role-list.vue?vue&type=style&index=0&id=2f0a4eab&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0a4eab"]])

export default __exports__